(function () {
  'use strict';

  var id = 'lister',
    listerMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').constant(id + '.CardText', {
    "cardView": {
      'tags': ['dimension'],
      "dimension": "{{dimension}}"
    },
    "detailView": {
      'tags': ['dimension'],
      "dimension": "{{dimension}}"
    }
  }).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/leaderboard/:cardId', {
      templateUrl: 'modules/app/lister/lister-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/leaderboard/:cardId/top', {
      templateUrl: 'modules/app/lister/lister-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences ONLY IF different than default icon for card type
    CardIconMap.register({
      "leaderboard": "leaderboard"
    });
  }]).factory(id + '.Utils', ['$filter', '$q', 'AggregationUtils', 'CardQueryResource', 'QueryES', 'Utils', 'ReportLinks', function ($filter, $q, AggUtils, CardQueryResource, QueryES, Utils, ReportLinks) {
    return {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        var path = "/lister/data",
          params = cfg.params;
        if (cfg.topLevelOnly) {
          params = {
            "_limit": Utils._try(function () {
              return cfg.params._limit || 10;
            }, 10),
            "_offset": 0,
            "order_by": Utils._try(function () {
              return cfg.params.order_by || '-measure[0].value';
            }, '-measure[0].value'),
            "numMeasuresToDisplay": cfg.params.numMeasuresToDisplay
          };
        }
        return CardQueryResource.getWithProgress(path, cfg.cardId, params, cfg.cardToPreview, 'lister-' + cfg.cardId);
      },
      isTimelineMeasure: function isTimelineMeasure(m) {
        return m.aggregation && _.contains(["COUNT"], m.aggregation.type) && m.valueProducer.statementProperty === "timestamp";
      },
      isDetailsMeasure: function isDetailsMeasure(m) {
        return m.details || _.contains(["SET", "LIST", "BENCHMARKS"], m.aggregation.type);
      },
      containsTimeline: function containsTimeline(measures) {
        var self = this;
        return _.any(measures, function (m) {
          return self.isTimelineMeasure(m);
        });
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      getMeasureTooltipDisplay: function getMeasureTooltipDisplay(measure) {
        if (!measure.field) {
          return null;
        }
        if (measure.field.type === 'DURATION') {
          return $filter('seconds')(measure.value);
        }
        return null;
      },
      getSentenceStats: function getSentenceStats(_stats, config) {
        var self = this;

        // copy stats to prevent changing original stats object
        var stats = angular.copy(_stats);
        _.each(stats, function (s, i) {
          var m = config.measures[i];
          s.measure = m.name;
          s.isAverage = m.aggregation.type === 'AVERAGE';
          s.isDuration = AggUtils.isDurationBasedMeasure(m);
          s.isScaledScore = m.valueProducer.statementProperty === 'result.score.scaled';
          s.isTimeline = self.isTimelineMeasure(m);
        });

        // remove stats for timelines (assumes timeline is last, so won't leave gap in stats array)
        stats = _.filter(stats, function (s) {
          return !s.isTimeline;
        });

        // format stats for sentence display
        _.each(stats, function (stat) {
          if (stat.isDuration) {
            stat.maxtooltip = $filter('seconds')(stat.max);
            stat.mintooltip = $filter('seconds')(stat.min);
            stat.avgtooltip = $filter('seconds')(stat.avg);
            var timeFormat = 'compactTime';
            stat.max = $filter(timeFormat)(stat.max) || "< 1 sec";
            stat.min = $filter(timeFormat)(stat.min) || "< 1 sec";
            stat.avg = $filter(timeFormat)(stat.avg) || "< 1 sec";
          } else {
            if (stat.isPercent || stat.isScaledScore) {
              stat.max *= 100;
              stat.min *= 100;
              stat.avg *= 100;
            }
            var decimalPlaces = stat.isAverage ? 1 : 0;
            stat.max = stat.max !== null ? $filter('number')(stat.max, decimalPlaces) : stat.max;
            stat.min = stat.min !== null ? $filter('number')(stat.min, decimalPlaces) : stat.min;
            stat.avg = stat.avg !== null ? $filter('number')(stat.avg, decimalPlaces) : stat.avg;
          }
          if (stat.isPercent) {
            stat.max += '%';
            stat.min += '%';
            stat.avg += '%';
          }
        });
        return stats;
      },
      transformData: function transformData(r, config, openModal, openGroupModal) {
        var self = this,
          containsTimeline = self.containsTimeline(config.measures);
        var useSplitColumns = config.dimensions.length === 2;

        // Transform results into more friendly format
        return _.map(r.results[0].result.data, function (v) {
          var listing = {
            dimension: config.dimensions[0],
            dimensionValue: v.values[0].value,
            displayName: AggUtils.getDimensionDisplay(v.values[0], config.dimensions[0]),
            ordinal: v.ordinal,
            possibleError: v.values[0].possibleError ? true : null,
            measures: _.map(v.aggregations, function (a, i) {
              var m = config.measures[i];
              a.measureName = m.name;
              a.valueProducer = m.valueProducer;
              a.aggregation = m.aggregation;
              a.filter = m.filter;
              var groupOfTypeHide = (m.valueProducer.type === "GROUP_OF_TYPE" || m.valueProducer.type === "GROUPS_OF_TYPE" || m.valueProducer.type === "FLAT_GROUPS_OF_TYPE") && (m.aggregation.type === "SET" || m.aggregation.type === "LIST");
              a.showModalLink = !groupOfTypeHide && self.isDetailsMeasure(m) && openModal;
              a.showGroupModalLink = m.valueProducer.type === "FLAT_GROUPS_OF_TYPE" && m.aggregation.type === "SET";
              a.showMeasureValue = !a.showModalLink && !a.showGroupModalLink;
              a.isTimeline = self.isTimelineMeasure(m);
              return a;
            }),
            openModal: openModal,
            openGroupModal: openGroupModal,
            getMeasureValueDisplayTruncated: function getMeasureValueDisplayTruncated(measure, index) {
              var measureValueDisplay = this.getMeasureValueDisplay(measure, index);
              var maxWidth = Math.max(measure.measureName.length - 6, 10);
              if (measureValueDisplay.length > maxWidth) {
                measureValueDisplay = "<span>" + measureValueDisplay.substring(0, maxWidth) + "...</span>";
              }
              return measureValueDisplay;
            },
            getMeasureValueDisplay: function getMeasureValueDisplay(measure, index) {
              var valueDisplay;
              if (_.contains(["COUNT", "DISTINCT_COUNT"], measure.aggregation.type)) {
                valueDisplay = $filter('number')(measure.value, 0);
              } else {
                valueDisplay = AggUtils.getMeasureValueDisplay(measure, measure);
              }

              // If we have a report link config, apply it.
              if (ReportLinks.hasLinkConfig(config, measure, index)) {
                valueDisplay = ReportLinks.applyLinkConfig(config, measure, valueDisplay, index, this.dimensionValue);
              }
              return valueDisplay;
            },
            getMeasureTooltipDisplay: self.getMeasureTooltipDisplay,
            containsTimeline: containsTimeline,
            timelineUniqueId: v.values[0].value
          };
          if (useSplitColumns) {
            //this can return only one value, ex: when includePeopleWithoutInteractions is true
            var values = Utils._try(function () {
              return v.values[0].value.split("+");
            }, [v.values[0].value, '--']);
            var labels = Utils._try(function () {
              return v.values[0].label.toString().split("+");
            }, [v.values[0].value, '--']);
            listing.splitColumns = [{
              value: values[0],
              label: labels[0]
            }, {
              value: values[1],
              label: labels[1]
            }].map(function (value, i) {
              return {
                displayName: AggUtils.getDimensionDisplay(value, config.dimensions[i]).trim()
              };
            });
          }
          return listing;
        });
      },
      getModalData: function getModalData(selectedRow, selectedMeasure, selectedMeasureIndex, parentConfig) {
        var self = this,
          config,
          defaultSortBy,
          modalSortControls = [];

        // for LIST and SET aggregations, configure for drill-down
        if (["LIST", "SET"].indexOf(selectedMeasure.aggregation.type) > -1) {
          // need to modify config for drill-down data
          config = angular.copy(parentConfig);
          config.measures = [{
            name: '',
            aggregation: {
              type: 'COUNT'
            },
            valueProducer: {
              type: 'STATEMENT_PROPERTY'
            }
          }];
          config.filter = config.filter || {};
          var filter = config.filter;
          if (!filter.and) {
            filter.and = [];
          }
          if (selectedMeasure.filter) {
            filter.and.push(selectedMeasure.filter);
          }

          // todo: what if dimension type == TIME?

          // if stmt property, filter results by setting 'filter.equals' to dimension value of this row
          if (selectedRow.dimension && selectedRow.dimension.type === 'STATEMENT_PROPERTY') {
            filter.and.push({
              equals: [{
                "fieldName": selectedRow.dimension.statementProperty,
                "values": {
                  "ids": [selectedRow.dimensionValue]
                }
              }]
            });
          }

          // set 'dimensions' of drill-down config to valueProducer of selectedMeasure
          config.dimensions = [selectedMeasure.valueProducer];
          modalSortControls.push({
            "title": parentConfig.measures[selectedMeasureIndex].name,
            "options": {
              "Ascending": "dimension[0].label",
              "Descending": "-dimension[0].label"
            }
          });
          if (selectedMeasure.aggregation.type === "LIST" && selectedMeasure.valueProducer.statementProperty === "timestamp") {
            modalSortControls.push({
              "title": "Interaction Count"
            });
          }
          defaultSortBy = "dimension[0].label";
        } else {
          var data = _.map(selectedMeasure.details, function (d) {
            if (selectedMeasure.valueProducer.type === "BENCHMARKS") {
              //in the case of benchmarks we really care about the underlying value producers
              selectedMeasure.valueProducer = {
                type: "TIME_BETWEEN"
              };
            }
            return {
              "label": d.name || d.label || "",
              "value": AggUtils.getMeasureValueDisplay(d, selectedMeasure)
            };
          });
          return $q.resolve({
            data: data,
            isDetailsData: true,
            sortControls: modalSortControls
          });
        }

        // setup config for listerResource
        var cardToPreview = {
            configuration: config
          },
          cfg = {
            cardId: "preview",
            cardToPreview: cardToPreview,
            params: {
              _limit: 10000,
              // We want "all", but set reasonable max.
              _offset: 0,
              order_by: defaultSortBy
            }
          };
        return self.fetchData(cfg).then(function (r) {
          var res = {
            cardToPreview: cardToPreview,
            data: _.map(self.transformData(r, config, null, null), function (d) {
              if (_.contains(["SET", "LIST"], selectedMeasure.aggregation.type) && selectedMeasure.valueProducer.statementProperty === "timestamp") {
                var format = selectedMeasure.valueProducer.format || 'LL';
                d.displayName = moment(d.dimensionValue).format(format);
              }
              return d;
            }),
            sortBy: defaultSortBy,
            sortControls: modalSortControls
          };
          if (selectedMeasure.aggregation.type === "SET") {
            _.each(res.data, function (d) {
              d.measures = [];
            });
          }
          return res;
        }, function () {
          // todo: fetch error
        });
      },
      hiddenMeasureFilter: function hiddenMeasureFilter(config) {
        return function (value, index) {
          if (config.hiddenMeasures) {
            return config.hiddenMeasures.indexOf(index) === -1;
          }
          return true;
        };
      }
    };
  }]).controller(id + ".CardConfiguration", ['$controller', '$rootScope', '$scope', 'Measures', 'Dimensions', function ($controller, $rootScope, $scope, Measures, Dimensions) {
    $scope.tempMeasures = listerMeasures;
    $scope.templateType = "leaderboard";
    $scope.getMeasures = Measures.getLeaderboardMeasures;
    $scope.allowCompoundDimensions = true;
    $scope.leaderboardHelpText = {
      helpTitle: 'Leaderboard',
      detailText: "In the Leaderboard section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. "
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    function cleanupListerSpecificProperties() {
      var resetDimension = Dimensions.isCompoundDimension($scope.workingConfig);
      if (resetDimension) {
        $scope.workingConfig.dimensions = [{
          "type": "STATEMENT_PROPERTY",
          "statementProperty": "actors.person.id"
        }];
        $scope.workingConfig.defaultSort = '-measure[0].label';
        $scope.updateCardWithWorkingConfig();
      }
    }
    $scope.cardChangeHandlers.push(cleanupListerSpecificProperties);

    //clear out any listerMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      listerMeasures = null;
    });
  }]).controller(id + ".Card", ['$filter', '$routeParams', '$scope', 'AggregationUtils', 'CardRegistry', 'CardText', 'CardDisplay', 'ExplorerService', 'Utils', id + '.CardText', id + '.Utils', 'wsEventNames', 'ReportValidationService', 'wsTimelineChart', 'CardQueryResource', function ($filter, $routeParams, $scope, AggUtils, CardRegistry, CardText, CardDisplay, ExplorerService, CentralUtils, ListerCardText, Utils, wsEvents, ReportValidationService, TimelineChart, CardQueryResource) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.hiddenMeasureFilter = Utils.hiddenMeasureFilter($scope.config);
    $scope.list = [];
    $scope.min = Math.min;
    $scope.defaultSummary = 'List of top ranking training and performance activities';
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    $scope.dimensions = AggUtils.getDimensionLabels({
      config: $scope.config,
      cardTextTemplate: ListerCardText
    });
    $scope.measure = $scope.config.measures.length > 0 ? $scope.config.measures[0].name : 'Statement Count';

    // Does this set of measures include a "timeline" measure?
    $scope.containsTimeline = Utils.containsTimeline($scope.config.measures);
    $scope.capitalizeEachWord = CentralUtils.capitalizeEachWord;
    $scope.dimensionDisplay = AggUtils.getDimensionDisplay;
    $scope.getMeasureTooltipDisplay = Utils.getMeasureTooltipDisplay;
    $scope.isArray = angular.isArray;

    // Are we in preview mode?
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.visibleMeasures = [];
    var timelineMeasures = [];

    // Move timeline to end
    _.each($scope.config.measures, function (m, i) {
      if ($scope.config.hiddenMeasures && _.contains($scope.config.hiddenMeasures, i)) {
        return;
      }
      m.isTimeline = Utils.isTimelineMeasure(m);
      if (!m.isTimeline) {
        $scope.visibleMeasures.push(m);
      } else {
        timelineMeasures.push(m);
      }
    });
    if ($scope.displayTimeline) {
      _.each(timelineMeasures, function (tm) {
        $scope.visibleMeasures.push(tm);
      });
    }

    // Function for fetching timelines (in the case of a timeline measure)
    var timelineSource = function timelineSource(currentPage) {
      return CardQueryResource.get("/lister/timeline", $scope.cardId, {
        dimensionIds: _.map(currentPage, function (l) {
          return l.timelineUniqueId;
        })
      }, cardToPreview);
    };
    var _cardViewOverflow = $scope.config.cardViewOverflow || 0;
    var _limit = CardDisplay.getLimitParam($scope.cardId);
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardId === 'preview' ? ExplorerService.getCard() : null,
      topLevelOnly: true,
      params: {
        order_by: $scope.config.defaultSort,
        _limit: _limit + _cardViewOverflow,
        numMeasuresToDisplay: $scope.numMeasuresToDisplay
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      $scope.list = Utils.transformData(r, $scope.config);
      $scope.dimensionInFooter = AggUtils.getDimensionInSentence($scope.config.dimensions[0], $scope.list.length !== 1);
      $scope.hasData = $scope.list.length > 0;
      if ($scope.hasData) {
        $scope.defaultSummary = "Top " + Math.min($scope.list.length, 10) + " distinct " + $scope.dimensionInFooter + ".";

        // Create the timeline charts for the timeline columns
        if ($scope.containsTimeline) {
          $scope.timelineLoading = true;
          TimelineChart.createMulti($scope.list, 'timelineUniqueId', timelineSource, $scope.config).then(function () {
            $scope.timelineLoading = false;
          });
        }
      }
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ['$routeParams', '$sanitize', '$scope', '$uibModal', 'AggregationUtils', 'CardQueryResource', '$filter', 'ReportValidationService', 'Logger', 'CardRegistry', 'CardText', 'CardUtils', 'Utils', id + '.CardText', 'wsTimelineChart', id + '.Utils', 'ExplorerService', 'Dimensions', function ($routeParams, $sanitize, $scope, $uibModal, AggUtils, CardQueryResource, $filter, ReportValidationService, Logger, CardRegistry, CardText, CardUtils, CentralUtils, ListerCardText, TimelineChart, Utils, ExplorerService, Dimensions) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.hiddenMeasureFilter = Utils.hiddenMeasureFilter($scope.config);

    // Sanity check for config and measures
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      Logger.error('Report config contains errors');
      return;
    }

    // Does this set of measures include a "timeline" measure?
    $scope.containsTimeline = Utils.containsTimeline($scope.config.measures);

    // Are we in preview mode?
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;

    // Set nav elements
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);

    // Sort control for timeline column (if one is present)
    var timelineSortControl = null;
    var dimensionLabels = AggUtils.getDimensionLabels({
      config: $scope.config,
      cardTextTemplate: ListerCardText,
      context: 'detailView'
    });
    var sortControls = [];
    var nonSortable = AggUtils.nonSortableControls($scope.config);
    var isCompoundDimension = Dimensions.isCompoundDimension($scope.config);
    var isSplitColumn = CentralUtils._try(function () {
      return isCompoundDimension && $scope.config.dimensions.length === 2;
    }, false);
    if (!$scope.config.hideDimension) {
      sortControls.push({
        "title": dimensionLabels[0],
        "options": {
          "Ascending": "dimension[0].label",
          "Descending": "-dimension[0].label"
        }
      });
      if (isSplitColumn) {
        sortControls.push({
          title: dimensionLabels[1],
          options: {
            "Ascending": "dimension[1].label",
            "Descending": "-dimension[1].label"
          }
        });
      }
    }

    // Create a sort control for each measure, and add to sortControls
    _.each($scope.config.measures, function (m, i) {
      if ($scope.config.hiddenMeasures && _.contains($scope.config.hiddenMeasures, i)) {
        return;
      }
      var nonSortableControls = nonSortable(m);
      var isTimeline = Utils.isTimelineMeasure(m),
        sortControl = {
          "title": m.name,
          "nonSortable": nonSortableControls.nonSortable,
          "nonSortType": nonSortableControls.nonSortType,
          "nonSortTypeName": nonSortableControls.nonSortTypeName,
          "options": isTimeline ? null : {
            "Ascending": "measure[" + i + "].value",
            "Descending": "-measure[" + i + "].value"
          },
          "isTimeline": isTimeline
        };
      sortControls.push(sortControl);

      // Remove timeline here, save it for end of array
      if (isTimeline) {
        timelineSortControl = sortControls.pop();
      }
    });

    // If the default sort is selected for a hidden measure, we should sort using a different measure
    var allowedMeasures = [];
    _.each(sortControls, function (s) {
      allowedMeasures = allowedMeasures.concat([s.options.Ascending, s.options.Descending]);
    });
    var overrideDefaultSort = $scope.config.defaultSort && !$scope.config.defaultSort.split(",").every(function (s) {
      return allowedMeasures.includes(s);
    }) && !isCompoundDimension;
    if (overrideDefaultSort) {
      $scope.config.defaultSort = allowedMeasures[allowedMeasures.length - 1];
    }

    // For clickable aggregation values
    $scope.openModal = function openModal(r, m, mi) {
      $scope.selectedRow = r;
      $scope.selectedMeasure = m;
      $scope.selectedMeasureIndex = mi;
      document.querySelector('html').classList.add('cursor-wait');
      Utils.getModalData(r, m, mi, $scope.config).then(function (modalData) {
        $scope.modalCardToPreview = modalData.cardToPreview;
        $scope.modalData = modalData.data;
        $scope.isDetailsData = modalData.isDetailsData;
        $scope.modalSortBy = modalData.sortBy;
        $scope.modalSortControls = modalData.sortControls;
      }).then(function () {
        return $uibModal.open({
          templateUrl: 'modules/app/lister/lister-modal.html',
          controller: id + '.Modal',
          backdrop: 'static',
          scope: $scope,
          size: 'lg'
        });
      }).catch(function (e) {
        Logger.error('Failed to load modal data', e);
      }).finally(function () {
        document.querySelector('html').classList.remove('cursor-wait');
      });
    };
    $scope.openGroupModal = function openGroupModal(r, m, mi) {
      $scope.selectedRow = r;
      $scope.selectedMeasure = m;
      $scope.selectedMeasureIndex = mi;
      $scope.values = r.measures[mi].value.split(r.measures[mi].valueProducer.delimiter);
      return $uibModal.open({
        templateUrl: 'modules/app/lister/lister-group-modal.html',
        controller: id + '.Modal',
        backdrop: 'static',
        scope: $scope,
        size: 'lg'
      });
    };

    // Function for fetching timelines (in the case of a timeline measure)
    var timelineSource = function timelineSource(currentPage) {
      return CardQueryResource.get("/lister/timeline", $scope.cardId, {
        dimensionIds: _.map(currentPage, function (l) {
          return l.timelineUniqueId;
        })
      }, cardToPreview);
    };
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('/lister/data/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: isPreview ? null : Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.displayPossibleError = false;
    var displayPossibleError = function displayPossibleError() {
      $scope.displayPossibleError = !$scope.displayPossibleError;
    };
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache",
      "displayPossibleError": displayPossibleError
    };

    // Function to post process fetched results
    var postFetch = function postFetch(r) {
      // Transform results into more friendly format
      $scope.list = Utils.transformData(r, $scope.config, $scope.openModal, $scope.openGroupModal);
      $scope.unableToDetermineTotal = !!r.unableToDetermineTotal;
      $scope.fetchedCount = CentralUtils.getIn(r, 'results[0].result.count', {
        alt: 0
      });

      // Is this the first time we've called this post fetch?
      var firstLoad = !$scope.hasData;
      $scope.count = r.results[0].result.count;
      if ($scope.count === 0 && r.results[0].result.data.length > 0) {
        $scope.count = r.results[0].result.data.length;
        // Preview requests typically have a count of zero, so we replace that here when we see it
      }
      $scope.hasData = $scope.count > 0;
      if ($scope.hasData) {
        // Tell the card pagenote about the data
        $scope.pagenote.setReportMetadata(r);

        // Only do this on first load
        if (firstLoad) {
          $scope.stats = Utils.getSentenceStats(r.results[0].result.stats, $scope.config);
          $scope.dimension = AggUtils.getDimensionInSentence($scope.config.dimensions[0], $scope.count !== 1);
          $scope.measure = $scope.config.measures.length > 0 ? $scope.config.measures[0].name : 'Statement Count';

          // Put timeline sort control at end of array
          if (timelineSortControl) {
            sortControls.push(timelineSortControl);
          }
          _.each(sortControls, function (s) {
            s.title = $sanitize(s.title);
          });
          $scope.sortControls = sortControls;
        }

        // Create the timeline charts for the timeline columns
        if ($scope.containsTimeline) {
          $scope.timelineLoading = true;
          TimelineChart.createMulti($scope.list, 'timelineUniqueId', timelineSource, $scope.config).then(function () {
            $scope.timelineLoading = false;
          });
        }
      }
      return {
        "count": $scope.count,
        "results": $scope.list,
        "unableToDetermineTotal": $scope.unableToDetermineTotal,
        "fetchedCount": $scope.fetchedCount
      };
    };
    var sortConfigOptions = {
      dimension: $scope.dimension,
      measures: $scope.measures
    };
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions);
    $scope.sortConfig.setSelections($scope.config.defaultSort || $scope.sortConfig.defaultSort, isCompoundDimension);
    $scope.pageSize = 50;
    $scope.defaultSortBy = "-measure[0].value";
    $scope.fetchData = function (params) {
      params = params || {
        "_limit": 10,
        "_offset": 0
      };

      // If we have not already defined an 'order_by' param, use the default set on the configuration
      if (!params.order_by) {
        params.order_by = $scope.config.defaultSort || "-measure[0].value";
      }
      var fetchCfg = {
        cardId: $scope.card.id,
        cardToPreview: isPreview ? ExplorerService.getCard() : null,
        params: params
      };
      return Utils.fetchData(fetchCfg).then(postFetch, function () {
        $scope.hasData = false;
      });
    };
  }]).controller(id + '.Modal', ['$scope', '$uibModalInstance', 'CardQueryResource', function ($scope, $uibModalInstance) {
    if ($scope.isDetailsData) {
      $scope.modalLeaderboard = {
        data: {
          allAttempts: {
            results: $scope.modalData
          }
        },
        templateUrl: 'modules/app/lister/modal-leaderboard.html',
        sortControls: $scope.modalSortControls
      };
    } else {
      $scope.modalLeaderboard = {
        data: {
          allAttempts: {
            results: $scope.modalData
          }
        },
        templateUrl: 'modules/app/lister/leaderboard.html',
        sortControls: $scope.modalSortControls,
        sortBy: $scope.modalSortBy
      };
    }
    $scope.close = function () {
      $uibModalInstance.close();
    };
  }]);
})();
